import React from 'react';

import { BottomSheet, Bullet, HelpCircleFillIcon, Text } from '@thefarmersfront/kitchen-mobile';

import { BOTTOM_SHEET_TITLES, GUIDE_MESSAGES } from '~/constants';

import styles from './GuideBottomSheet.module.scss';

/**
 * GuideBottomSheet 컴포넌트 props type 정의
 * @category GuideBottomSheet
 */
export type TypeGuideBottomSheetProps = {
  /** 툴팁의 표시 여부 */
  open: boolean;
  /** 툴팁의 표시 여부를 변경하는 이벤트 */
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

/**
 * @description 인증번호 관련 안내 표시 바텀시트 컴포넌트
 * @param TypeGuideBottomSheetProps
 * @returns - React.JSX.Element / GuideBottomSheet 컴포넌트 반환
 */
const GuideBottomSheet = ({ open, setOpen }: TypeGuideBottomSheetProps) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button className={styles['bottom-sheet-button']} type="button" onClick={() => setOpen(true)}>
        <HelpCircleFillIcon size={16} color="gray600" />
        <Text size="small" color="secondary">
          {GUIDE_MESSAGES.ASK_VERIFICATION_CODE_DELIVERY}
        </Text>
      </button>
      <BottomSheet
        id="guide-bottom-sheet"
        open={open}
        title={BOTTOM_SHEET_TITLES.ASK_VERIFICATION_CODE_DELIVERY}
        buttonConfig={{
          buttonType: 'alert',
          confirmColor: 'secondary',
          onConfirm: handleClose,
        }}
        onClose={handleClose}
      >
        <div className={styles['bottom-sheet-content']}>
          {GUIDE_MESSAGES.VERIFICATION_CODE.split('\n').map((msg, idx) => {
            const keyOfMsg = `guide-msg-${idx}`;
            return (
              <div className={styles['bottom-sheet-guide-msg']} key={keyOfMsg}>
                <Bullet size="small" className={styles['bullet']} />
                <Text size="large" color="secondary">
                  {msg}
                </Text>
              </div>
            );
          })}
        </div>
      </BottomSheet>
    </>
  );
};

export default GuideBottomSheet;
